import { ROUTERS } from "constants/routes.constant";
import { RouteProps } from "models/common";
import { lazy } from "react";

const Login = lazy(() => import("../pages/login"));
const UserRegister = lazy(() => import("../pages/user-register"));
const ConfirmEmailPW = lazy(() => import("../pages/confirm-email-pw"));
const ResetPassword = lazy(() => import("../pages/reset-password"));
const UserManagement = lazy(() => import("../pages/user-management"));
const FormDetail = lazy(() => import("../pages/form-detail"));
const Approve = lazy(() => import("../pages/approve"));
const PhotographingDocument = lazy(
  () => import("../pages/photographing-document"),
);
const SupplierScreenInputForm = lazy(
  () => import("../pages/supplier-screen-input-form"),
);
const OrganizationList = lazy(() => import("../pages/organization-list"));
const ServiceList = lazy(() => import("../pages/service-list"));
const NotificationSetting = lazy(() => import("../pages/notification-setting"));
const ConfirmChangeEmail = lazy(() => import("../pages/confirm-change-email"));
const LinkManagement = lazy(() => import("../pages/link-management"));

export const noauthRoutes: RouteProps[] = [
  {
    path: ROUTERS.LOGIN,
    component: <Login />,
  },
  {
    path: ROUTERS.USER_REGISTER,
    component: <UserRegister />,
  },
  {
    path: ROUTERS.CONFIRM_EMAIL,
    component: <ConfirmEmailPW />,
  },
  {
    path: ROUTERS.RESET_PASSWORD,
    component: <ResetPassword />,
  },
  {
    path: ROUTERS.CONFIRM_CHANGE_EMAIL,
    component: <ConfirmChangeEmail />,
  },
];

export const routes: RouteProps[] = [
  {
    path: ROUTERS.USER_MANAGEMENT,
    component: <UserManagement />,
  },
  {
    path: ROUTERS.APPROVE,
    component: <Approve />,
  },
  {
    path: ROUTERS.PHOTOGRAPHING_DOCUMENT,
    component: <PhotographingDocument />,
  },
  {
    path: ROUTERS.SUPPERLIER_SCREEN_INPUT_FORM,
    component: <SupplierScreenInputForm />,
  },
  {
    path: ROUTERS.DETAIL_FORM,
    component: <FormDetail />,
  },
  {
    path: ROUTERS.ORGANIZATION_LIST,
    component: <OrganizationList />,
  },
  {
    path: ROUTERS.SERVICE_MANAGEMENT,
    component: <ServiceList />,
  },
  {
    path: ROUTERS.NOTIFICATION_SETTING,
    component: <NotificationSetting />,
  },
  {
    path: ROUTERS.LINK_MANAGEMENT,
    component: <LinkManagement />,
  },
];
